/**
 * Task Actions
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getProjectWithoutRefresh, getProjectList } from "../projects";
import { resetUploadLoading } from "../project";
// for setting current page no of task grid
export const setTaskCurrentPageNo = createAsyncThunk(
  "taskCurrentPageNo/setTaskCurrentPageNo",
  async (data, thunkAPI) => {
    return data;
  }
);

// for getting all tasks
export const getTaskList = createAsyncThunk(
  "taskList/getTaskList",
  async (data, thunkAPI) => {
    let selectedTab = thunkAPI.getState().project.selectedTab;
    let searchText = thunkAPI.getState().project.searchText;
    const filterTask = thunkAPI.getState().project.filterTask;

    try {
      let headers = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
      };
      let status;
      let url = `${
        process.env.REACT_APP_BASE_URL
      }api/projects/tasks?pageNumber=${data.pageNumber || 1}&pageSize=${
        data.pageSize || 20
      }`;

      if (selectedTab === 2) {
        url += `&assigned_to_me=1`;
      } else if (data?.departmentID) {
        url += `&department_id=${data.departmentID}`;
      }
      if (searchText.length > 0) {
        url += `&search=${searchText}`;
      }
      if (filterTask.status.length > 0) {
        if (
          filterTask.status.toLowerCase() === "on hold" ||
          filterTask.status.toLowerCase() === "onhold"
        ) {
          status = ["onhold"];
        } else {
          status = [filterTask.status];
        }
        url += `&status=${JSON.stringify(status)}`;
      }
      if (data.status) {
        url += `&status=${JSON.stringify(data.status)}`;
      }

      const resp = await axios.get(url, headers);
      return { data: resp.data, pageNumber: data.pageNumber };
    } catch (error) {
      console.log(error);
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

export const getKanbanTaskList = createAsyncThunk(
  "taskList/getKanbanTaskList",
  async (data, thunkAPI) => {
    let selectedTab = thunkAPI.getState().project.selectedTab;
    let searchText = thunkAPI.getState().project.searchText;
    let pageNo = thunkAPI.getState().project.tasksCurrentPageNo;
    let status;

    let url;
    if (selectedTab === 1) {
      url = `${process.env.REACT_APP_BASE_URL}api/projects/tasks?pageNumber=${pageNo}&pageSize=250`;
    } else if (selectedTab === 2) {
      url = `${process.env.REACT_APP_BASE_URL}api/projects/tasks?assigned_to_me=1&pageNumber=${pageNo}&pageSize=250`;
    } else if (data.departmentID) {
      url = `${process.env.REACT_APP_BASE_URL}api/projects/tasks?department_id=${data.departmentID}&pageNumber=${pageNo}&pageSize=250`;
    }

    if (searchText.length > 0) {
      url += `&search=${searchText}`;
    }

    try {
      let headers = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
      };
      if (status) {
        headers.params = { status: JSON.stringify(status) };
      }
      const resp = await axios.get(url, headers);
      return { data: resp.data, pageNo };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for getting a particular task in task details dialog
export const getTask = createAsyncThunk(
  "task/getTask",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/projects/tasks/${data}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for getting task history
export const getTaskHistory = createAsyncThunk(
  "taskHistory/getTaskHistory",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/projects/tasks/${data}/history`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for changing Task Status
export const changeTaskStatus = createAsyncThunk(
  "taskStatus/changeTaskStatus",
  async (data, thunkAPI) => {
    try {
      const { taskID, status, confirmed, approval_notes } = data;
      let d;
      if (confirmed) {
        d = JSON.stringify({
          status: status,
          confirmed,
        });
      } else if (approval_notes) {
        d = JSON.stringify({
          status: status,
          approval_notes,
        });
      } else {
        d = JSON.stringify({
          status: status,
        });
      }

      var config = {
        method: "put",
        url: `${process.env.REACT_APP_BASE_URL}api/projects/tasks/change-status/${taskID}`,
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
        data: d,
      };

      const response = await axios(config);
      return { ...data, updateData: response.data.data };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data);
      } else {
        return thunkAPI.rejectWithValue(error);
      }
    }
  }
);

// for claiming a task
export const claimTask = createAsyncThunk(
  "taskClaim/claimTask",
  async (data, thunkAPI) => {
    try {
      const departmentID = thunkAPI.getState().project.selectedDepartment;
      var config = {
        method: "put",
        url: `${process.env.REACT_APP_BASE_URL}api/projects/tasks/claim/${data}`,
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
      };

      const resp = await axios(config);
      // await thunkAPI.dispatch(setTaskCurrentPageNo(1));
      // setTimeout(async () => {
      //   await thunkAPI.dispatch(getTaskList({ departmentID }));
      // }, 500);
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for assigning someone to task
export const assignTask = createAsyncThunk(
  "taskAssign/assignTask",
  async (data, thunkAPI) => {
    const { task_id, user_id, user } = data;
    var d = JSON.stringify({
      user_id: user_id,
    });

    try {
      var config = {
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}api/projects/tasks/${task_id}/team-member`,
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
        data: d,
      };

      await axios(config);
      return { taskID: task_id, user };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for unassigning from a task
export const unassignTask = createAsyncThunk(
  "taskUnassign/unassignTask",
  async (data, thunkAPI) => {
    const { task_id, member_id } = data;
    const departmentID = thunkAPI.getState().project.selectedDepartment;

    try {
      var config = {
        method: "delete",
        url: `${process.env.REACT_APP_BASE_URL}api/projects/tasks/${task_id}/team-member/${member_id}`,
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
      };

      await axios(config);
      // thunkAPI.dispatch(setTaskCurrentPageNo(1));
      // setTimeout(() => {
      //   thunkAPI.dispatch(getTaskList({ departmentID }));
      // }, 500);
      return task_id;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for uploading deliverable to a task
export const changeDeliverableLoading = createAsyncThunk(
  // Changing Status of Uploading Deliverable
  "changeDeliverableLoading/changeDeliverableLoading",
  async (data, thunkAPI) => {
    return data;
  }
);

export const upload = async (
  data,
  dispatch,
  handleError,
  setUploadProgress
) => {
  dispatch(changeDeliverableLoading(true));

  const { taskID, files } = data;
  const totalFiles = files.length;
  let index = 1;

  for (let file of files) {
    let formData = new FormData();
    formData.append("deliverables", file);
    try {
      await axios
        .put(
          `${process.env.REACT_APP_BASE_URL}api/projects/tasks/upload-deliverables/${taskID}`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              "Content-type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              // Calculate the progress for the current file
              const fileProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
              setUploadProgress({ progress: fileProgress, index, totalFiles });
            },
          }
        )
        .then((resp) => {
          if (index !== totalFiles) {
            setUploadProgress({ progress: null, index, totalFiles });
          }
          index = index + 1;
        });
    } catch (error) {
      dispatch(resetUploadLoading());
      if (error.response) {
        if (handleError) {
          handleError(error?.response?.data?.message || error.response.data);
        }
      } else {
        if (handleError) {
          handleError(error.message);
        }
      }
    }
  }
  setTimeout(function () {
    setUploadProgress(null);
    dispatch(uploadDeliverable(taskID));
  }, 15000);
};

export const uploadDeliverable = createAsyncThunk(
  // fetch task and task list after uploading deliverable to avoid 403 forbidden error
  "deliverableUpload/uploadDeliverable",
  async (data, thunkAPI) => {
    try {
      const departmentID = thunkAPI.getState().project.selectedDepartment;
      // thunkAPI.dispatch(setTaskCurrentPageNo(1));
      // setTimeout(() => {
      //   thunkAPI.dispatch(getTaskList({ departmentID }));
      // }, 500);
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/projects/tasks/${data}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      return { taskID: data, data: resp?.data?.data };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for deleting deliverable from a task
export const deleteDeliverable = createAsyncThunk(
  "deleteDeliverable/deliverableDelete",
  async (data, thunkAPI) => {
    const { taskID, deliverableID } = data;
    try {
      await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/projects/tasks/deliverables/${deliverableID}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-type": "multipart/form-data",
          },
        }
      );

      return { taskID: taskID, deliverableID: deliverableID };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

// for setting task filter status value
export const setTaskFilterStatus = createAsyncThunk(
  "filter/setTaskFilterStatus",
  async (data, thunkAPI) => {
    return data;
  }
);

// get project counts
export const getTasksStats = createAsyncThunk(
  "projectList/getTasksStats",
  async (data, thunkAPI) => {
    try {
      let selectedTab = thunkAPI.getState().project.selectedTab;

      let url = `${process.env.REACT_APP_BASE_URL}api/projects/tasks/counts?search`;

      if (selectedTab === 2) {
        url += `&assigned_to_me=1`;
      } else if (data?.departmentID) {
        url += `&department_id=${data.departmentID}`;
      }

      const resp = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
      });
      return { data: resp.data?.data };
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
